import React from 'react';

const Categories = () => <h2>Under Construction</h2>;

export default Categories;
